import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

import { Navigation } from "../components/Navigation";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { ServicesSection } from "../components/ServicesSection";
import { ReviewsSection } from "../components/ReviewsSection";
import { GallerySection } from "../components/GallerySection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { FRESHA_BOOKING_URL } from "../config";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function HomePage() {
  const [services, setServices] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [businessInfo, setBusinessInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (!loading && location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
      }
    }
  }, [loading, location.hash]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, reviewsRes, businessRes] = await Promise.all([
          axios.get(`${API}/services`),
          axios.get(`${API}/reviews`),
          axios.get(`${API}/business-info`),
        ]);

        setServices(servicesRes.data);
        setReviews(reviewsRes.data);
        setBusinessInfo(businessRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Fehler beim Laden der Daten");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleBookingClick = () => {
    window.open(FRESHA_BOOKING_URL, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="font-playfair text-xl text-[#1A1A1A]">Urban Beauty</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navigation onBookingClick={handleBookingClick} />

      <main>
        <HeroSection onBookingClick={handleBookingClick} />
        <AboutSection onBookingClick={handleBookingClick} />
        <ServicesSection services={services} onBookService={handleBookingClick} />
        <GallerySection />
        <ReviewsSection reviews={reviews} />
        <ContactSection businessInfo={businessInfo} />
      </main>

      <Footer businessInfo={businessInfo} />
    </>
  );
}
